import React from 'react';

const JiraTicketForm: React.FC = () => {
  return (
    <div>
      <h2>Jira Ticket Form Placeholder</h2>
      <p>If you see this, the component is rendering.</p>
    </div>
  );
};

export default JiraTicketForm;
